export default "__VITE_ASSET__D7lh8HWl__"